"use client";
import React, { useRef } from "react";
import { useScroll, useTransform, motion } from 'framer-motion';
import Container from "components/Container";
import Paragraph from "components/Paragraph";
import HeadingTwo from "components/HeadingTwo";
import { Helmet } from "react-helmet-async";

function Portfolio() {

    const container = useRef(null);
    const { scrollYProgress } = useScroll({
        target: container,
        offset: ["start end", "end start"]
    })
    const height = useTransform(scrollYProgress, [0, 0.9], [50, 0])


    return (
        <div ref={container}>
            <Helmet>
                <title>Portfolio • SURYA</title>
                <meta name="description" content="" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>

            <Container className="pb-6 md:pb-12 4xl:pb-96">
                <div className="w-[340px] sm:w-[480px] lg:w-[620px] 4xl:w-[800px] mt-32 md:mt-48 4xl:mt-[440px] lg:mb-12 ">
                    <HeadingTwo className=''>Creating <span className='bg-lemone text-smoke'>next level</span> digital products</HeadingTwo>
                </div>
                <Paragraph className='text-smoke text-xl text-justify'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum, non labore! Atque quia quo voluptas eveniet assumenda quasi error dolorem labore eligendi quisquam odio, illo unde dolore. Repellat, tenetur. Quo.</Paragraph>
            </Container>
            <motion.div
                style={{ height }}
                className="relative bg-[#FBF4E6]"
            >
                <div className="h-[1550%] w-[120%] left-[-10%] bg-[#FBF4E6] z-10 overflow-hidden absolute rounded-b-[50%]"
                    style={{ boxShadow: '0px 60px 50px rgba(0, 0, 0, 0.748)' }}
                >
                    <h2 className="text-center text-[4rem] md:text-[8rem] mt-16 md:mt-0 font-bold text-smoke">
                        Port<span className="text-[2rem] md:text-[4rem] text-smoke  ">folio</span>
                    </h2>
                </div>
            </motion.div>
        </div>
    );
}

export default Portfolio;